import React from "react";
import "./About.css";

export default function Writing() {
  return (
    <>
      <p className="copy">
        In 2018 Niamh gained an MA in Prose Fiction from UEA, and she began her creative writing PhD at the University of Glasgow in 2020, funded by the AHRC (SGSAH). She writes an occasional newsletter, <a
          rel="noreferrer"
          target="_blank"
          href="https://niamhgordon.substack.com/"
        >
          notes from home
        </a>, about books, writing and motherhood; if you would like to read it, you can subscribe <a
          rel="noreferrer"
          target="_blank"
          href="https://niamhgordon.substack.com/"
        >
          here
        </a>.
      </p>
      <p>
        She has written a novel, of which more soon!
      </p>
      <p>
        A selection of published writing is linked below:
      </p>
        <ul className="writing-list">
          <li>‘<a rel="noreferrer"
          target="_blank" href="https://creativecritical.net/expulsion-niamh-gordon/">expulsion</a>’ – creative non-fic, <a rel="noreferrer"
          target="_blank" href="https://creativecritical.net">creative-critical.net</a></li>
          <li>‘<a rel="noreferrer"
          target="_blank" href="https://www.babestation.org.uk/shop/p/vwebrwshbrlsa6c55il6qabz93mmd3">four poems</a>’ – poetry pamphlet, Babe Station for ‘Sorry about the mess’ exhibition</li>
          <li>‘<a rel="noreferrer"
          target="_blank" href="https://www.guttermag.co.uk/getgutter/p/gutter-31">The Rothko room</a>’ – short fiction in Gutter</li>
          <li>
            ‘<a
              rel="noreferrer"
              target="_blank"
              href="https://uk.bookshop.org/p/books/don-t-even-ask-too-hot-new-writing-scotland-42-kirstin-innes/7704972?ean=9781906841614"
            >Food</a>’ - short fiction in{" "}
            
              New Writing Scotland
          </li>
          <li>
            ‘<a
              rel="noreferrer"
              target="_blank"
              href="https://eprints.gla.ac.uk/325834/1/325834.pdf"
            >Behind Some of the Scenes at the Museum</a>’ – creative non-fiction, DeathWrites Newspaper
            
          </li>
          <li>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://www.strixleeds.com/shop/strix-10"
            >‘Birth lament’ and Dispatch from now’</a> - two poems,
              Strix
          </li>
          <li>
            ‘<a
              rel="noreferrer"
              target="_blank"
              href="https://thepolyphony.org/2021/11/11/grief-reading-and-narrative-time/"
            >Grief, reading, and narrative time</a>’ - essay,
              The Polyphony
          </li>
          <li>
            ‘<a
              href="https://returntrip.bigcartel.com/product/return-trip-spring-summer-2021"
              target="_blank"
              rel="noreferrer"
            >Covering Ground in Berlin</a>’ – short fiction, Return Trip
          </li>
          <li>
            ‘<a
              target="_blank"
              href="https://flashfictionmagazine.com/blog/2020/10/01/a-rich-mans-game/"
              rel="noreferrer"
            >A Rich Man’s Game</a>’ – flash fiction,
              Flash Fiction Magazine
          </li>
        </ul>
    </>
  );
}
